
import { BlastEvent, ShapeType } from '../types';
import { ShapeUtils } from '../logic/physics/ShapeUtils';

export const seedRandom = (seed: string, idx: number) => {
    let h = 0x811c9dc5;
    const str = seed + idx.toString();
    for (let i = 0; i < str.length; i++) {
        h ^= str.charCodeAt(i);
        h = Math.imul(h, 0x01000193);
    }
    return ((h >>> 0) / 4294967296);
};

export const lerpColor = (a: string, b: string, t: number) => {
    const parse = (c: string) => c.match(/\w\w/g)?.map(x => parseInt(x, 16)) || [0,0,0];
    const c1 = parse(a), c2 = parse(b);
    const r = Math.round(c1[0] + (c2[0] - c1[0]) * t);
    const g = Math.round(c1[1] + (c2[1] - c1[1]) * t);
    const bl = Math.round(c1[2] + (c2[2] - c1[2]) * t);
    return `rgb(${r},${g},${bl})`;
};

export const getRadiusAtAngle = (angle: number, e: BlastEvent, baseRadius: number) => {
    const rotRad = (e.rotation || 0) * Math.PI / 180;
    const effectiveAngle = angle - rotRad;
    
    if (e.morphData) {
        return ShapeUtils.getInterpolatedRadiusAtAngle(effectiveAngle, e.morphData.from, e.morphData.to, e.morphData.factor, baseRadius, e.morphData.baseRadius);
    }
    if (!e.shape || e.shape === 'CIRCLE') return baseRadius;
    // For static shapes, use getInterpolatedRadiusAtAngle with factor 0 for consistency
    return ShapeUtils.getInterpolatedRadiusAtAngle(effectiveAngle, e.shape, e.shape, 0, baseRadius);
};

export const drawBlastShape = (ctx: CanvasRenderingContext2D, e: BlastEvent, radius: number) => {
    ctx.beginPath();
    if (e.morphData) {
        ctx.save();
        ctx.translate(e.pos.x, e.pos.y);
        ctx.rotate((e.rotation || 0) * Math.PI / 180);
        ShapeUtils.traceInterpolatedShape(ctx, {x:0, y:0}, e.morphData.from, e.morphData.to, e.morphData.factor, radius, e.morphData.baseRadius);
        ctx.restore();
    } else if (!e.shape || e.shape === 'CIRCLE') {
        ctx.arc(e.pos.x, e.pos.y, radius, 0, Math.PI * 2);
    } else {
        ctx.save();
        ctx.translate(e.pos.x, e.pos.y);
        ctx.rotate((e.rotation || 0) * Math.PI / 180);
        ShapeUtils.traceInterpolatedShape(ctx, {x:0, y:0}, e.shape, e.shape, 0, radius);
        ctx.restore();
    }
};
